/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * A React component for Audio Forward Icon.
 *
 * @author Sai Haripriya Yerra, Ramani Govindaraju
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AudioRewind = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <path
        fill="#252525"
        fillRule="nonzero"
        d="M8.969 0C13.956 0 18 4.029 18 9s-4.044 9-9.031 9C4.4 18 .568 14.604.007
        10.124a.887.887 0 1 1 1.76-.22c.45 3.593 3.53 6.321 7.202 6.321 4.008 0
        7.256-3.235 7.256-7.225 0-3.99-3.248-7.225-7.256-7.225-1.309
        0-2.561.345-3.652.98l1.565 1.564a.4.4 0 0 1-.284.683l-4.199-.01a.4.4
        0 0 1-.399-.4V.402A.4.4 0 0 1 2.683.12l1.345 1.345A9.022 9.022 0 0 1
        8.968 0z"
      />
      <path
        fill="#252525"
        d="M13.576 9.43c0 1.247-.204 2.17-.613 2.77-.408.598-1.037.898-1.887.898-.823
        0-1.444-.31-1.863-.928-.418-.619-.627-1.532-.627-2.74 0-1.26.203-2.188.61-2.785s1.034-.896
        1.88-.896c.824 0 1.446.313 1.868.938.421.625.632 1.54.632 2.744zm-3.491
        0c0 .876.076 1.504.227 1.883.151.38.406.569.764.569.352
        0 .606-.192.762-.576.156-.384.234-1.01.234-1.875
        0-.876-.079-1.505-.236-1.888-.158-.382-.411-.573-.76-.573-.355
        0-.608.191-.761.573-.153.383-.23 1.012-.23 1.888zM7.43
        13H5.923V8.87l.015-.68.024-.742c-.25.25-.425.415-.522.493l-.82.66-.728-.909
        2.3-1.83h1.24V13z"
      />
    </g>
  </SvgIcon>
);

export default AudioRewind;



// WEBPACK FOOTER //
// ./src/js/icons/AudioRewind.jsx